import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { PaymentStatusResponse } from "../models/payment-status.response";
import { PaymentApiRequest } from "../models/payment.resquest";
import { PaymentApiResponse } from "../models/payment.response";

@Injectable({
  providedIn: 'root'
})
export class PaymentApiService {

  constructor(
    private readonly httpClient: HttpClient,
  ) { }


  public requestPaymentLink(request: PaymentApiRequest): Observable<PaymentApiResponse> {
    return this.httpClient.post<PaymentApiResponse>('https://payment-api.grupohipersaude.com.br/api/payments/link', request);
  }

  public getPaymentStatus(id: string): Observable<PaymentStatusResponse> {
    return this.httpClient.get<PaymentStatusResponse>(`https://payment-api.grupohipersaude.com.br/api/payments/status/${id}`);
  }

}
